import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';

/**
 * Home page is the new-frontend-system's customizable dashboard
 * (CustomHomepageGrid): users pick their own widgets from a palette rather
 * than us hard-coding a layout. `@backstage/plugin-home` already ships
 * starred-entities / toolkit / random-joke widgets that auto-attach to
 * `page:home`'s `widgets` input (HomePageWidgetBlueprint's default
 * attachTo). This module adds one more option to that palette: the latest
 * DevHub announcements, so the announcements plugin (Wave 1) has a home
 * surface in addition to the notifications bell.
 */
const announcementsWidget = HomePageWidgetBlueprint.make({
  name: 'announcements',
  params: {
    title: 'Announcements',
    description: 'Latest announcements from the DevHub team',
    components: async () => {
      const { AnnouncementsCard } = await import(
        '@backstage-community/plugin-announcements'
      );
      return { Content: () => <AnnouncementsCard max={5} /> };
    },
  },
});

/**
 * dev-quotes (Wave 2) — a lighthearted developer-quote card. The package has
 * no `/alpha` export (it's a legacy-shaped `.` FrontendPlugin exposing a
 * whole standalone page), but it also exports a plain `DevQuote()` React
 * component we can embed directly, so it becomes a widget option here
 * instead of a second page/nav entry.
 */
const devQuotesWidget = HomePageWidgetBlueprint.make({
  name: 'dev-quotes',
  params: {
    title: 'Dev Quote',
    description: 'A random developer-themed quote',
    components: async () => {
      const { DevQuote } = await import(
        '@parsifal-m/plugin-dev-quotes-homepage'
      );
      return { Content: () => <DevQuote /> };
    },
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [announcementsWidget, devQuotesWidget],
});
